export default "__VITE_ASSET__BjpUqbt8__"